import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            gsap.to(".hospital-detail .hero-item .item-text", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: defaultEase,
            })

            gsap.to(".hospital-detail .hero-item .item-img", {
                y: 0,
                opacity: 1,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase,
            })

            gsap.to(".hospital-detail .hero-item .item-img img", {
                y: 0,
                opacity: 1,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase,
            })

            //--

            gsap.to(".hospital-detail .info-item", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".hospital-detail .info-item",
                    start: "top bottom-=200px",
                }
            })

            gsap.to(".hospital-detail .info-item .item-text", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.1,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".hospital-detail .info-item",
                    start: "top bottom-=200px",
                }
            })

            gsap.to(".hospital-detail .info-item .default-btn", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.2,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".hospital-detail .info-item",
                    start: "top bottom-=200px",
                }
            })

            //--

            gsap.to(".hospital-detail .link-item .link-row .item", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                stagger: 0.1,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".hospital-detail .link-item",
                    start: "top bottom-=200px",
                }
            })

            //--

            gsap.to(".list-img-items-container .item-title", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".list-img-items-container",
                    start: "top bottom-=200px",
                }
            })

            gsap.to(".list-img-items-container ul li", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.1,
                stagger: 0.1,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".list-img-items-container",
                    start: "top bottom-=200px",
                }
            })
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });

    //--

    if ($(".marquee-container").length) {
        let timeline = gsap.timeline();
        let sentenceWidth = document.querySelector('.marquee-container .marquee-item').clientWidth;
        timeline.pause()

        // Init timeline and register events.
        function init() {
            setTimeline();
            window.addEventListener('resize', handleResize);

            let marqueeOffset = $(".marquee-container").offset();
            $(window).scroll(function () {
                if ($(this).scrollTop() + window.innerHeight > marqueeOffset.top) {
                    timeline.play()
                } else {
                    timeline.pause()
                }
            });
        }

        // Add marquee animations to timeline.
        function setTimeline() {
            timeline
                .add(createMarquee(document.querySelector('#marquee-item-1'), 'right'), 0)
        }

        // Create single marquee animation.
        function createMarquee(element, direction) {
            const distance = sentenceWidth * 2;
            return gsap.timeline()
                .to(element, {
                    duration: 20,
                    ease: 'none',
                    x: direction === 'left' ? distance : -distance,
                    onComplete() {
                        timeline.play(0);
                    },
                    onReverseComplete() {
                        timeline.reverse(0);
                    },
                },
                );
        }

        // Reset timeline on resize.
        function handleResize() {
            sentenceWidth = document.querySelector('.marquee-container .marquee-item').clientWidth;
            timeline.seek(0);
            timeline.clear();
            setTimeline();
        }

        init();
    }

    //--

    $(".list-img-items-container ul li").mousemove(function (e) {
        let itemPosition = $(this).offset()
        let imgItem = $(this).find(".img-item");
        let mouseY = e.pageY;
        let mouseX = e.pageX;
        let calcY = (((mouseY - itemPosition.top) / $(this).height()) * 10) - 10
        let calcX = (((mouseX - itemPosition.left) / $(this).width()) * 30) - 30

        if (imgItem.length) {
            gsap.to(imgItem, {
                y: calcY,
                x: calcX,
                duration: 0.6,
            })
        }

        //-

        $(this).addClass("active")
        $(this).siblings().removeClass("active")
    });

    $(".list-img-items-container ul").mouseleave(function () {
        $(this).find("li").removeClass("active")
    });
})